import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignOrderService } from 'src/app/services/campaign-order.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.sass']
})
export class BlacklistComponent implements OnInit {

  idOrderData: string;
  blacklistOk = false;

  constructor(private route: ActivatedRoute,
    private service: CampaignOrderService) { }

  ngOnInit(): void {
    this.idOrderData = this.route.snapshot.paramMap.get('idOrderData');
  }

  SendToBlacklist() {
    if (this.blacklistOk) {
      Swal.fire({
        icon: 'info',
        title: 'Já cancelou a sua subscrição anteriormente',
        text: 'Já pode sair desta página'
      });
    }
    else {
      this.service.postCampaignCrmBlacklist(this.idOrderData).subscribe(resp => {
        Swal.fire({
          icon: 'info',
          title: 'Contacto anulou a subscrição de comunicações com sucesso',
          text: 'Já pode sair desta página'
        });
        this.blacklistOk = true;
      }, (err) => {
        this.blacklistOk = false;
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro'
        });
      });
    }

  }

}
